import { Box, Typography } from '@mui/material';
import { FC, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CampaignModal } from 'shared/Modals/CampaignModal';
import { useTheme } from 'themes/themeProvider';
import { campaign } from './campaigns';

export const CampaignControllerModal: FC = () => {
  const { themeKey } = useTheme();
  const currentCampaign = campaign[themeKey];
  const navigate = useNavigate();

  const [open, setOpen] = useState<boolean>(Boolean(currentCampaign));

  const handleClose = useCallback(() => setOpen(false), []);

  const route = currentCampaign?.route;

  const handlePrimary = useCallback(() => {
    try {
      if (route) {
        navigate(route);
      }
    } finally {
      handleClose();
    }
  }, [route, navigate, handleClose]);

  const handleSecondary = useCallback(() => {
    handleClose();
  }, [handleClose]);

  if (!currentCampaign || !open) return null;

  const { mainText, primaryButtonText, secondaryButtonText, title, image, imageStyle } = currentCampaign;

  const content = (
    <Box>
      {image && (
        <Box mb={2}>
          <img src={image} alt={title} style={imageStyle} />
        </Box>
      )}

      <Box>
        <Typography component='div' variant='body1' style={{ whiteSpace: 'pre-line' }}>
          {mainText}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <CampaignModal
      title={title}
      content={content}
      primaryButtonText={primaryButtonText}
      secondaryButtonText={secondaryButtonText}
      onClose={handleClose}
      primaryButtonHandler={handlePrimary}
      secondaryButtonHandler={handleSecondary}
      showCloseIcon
    />
  );
};
